import {
  ADD,
  REMOVE,
  DISSMISS_INTERVAL,
  SET_USER_THEME_OPTIONS,
  SET_DEFAULT_THEME,
  SET_LAYOUT_CONFIG,
  SET_AVAILABLE_LOCALES,
  SET_QUERY_LOCALE,
} from './consts';
import createMessage from './helpers';
import { objectToCssVars } from '@/helpers/objectToCssVars';
import themes from '@/config/themes';

import store from '../../index';

const tinycolor = require('tinycolor2');

export default {
  [ADD](
    { commit, state },
    { text, type = 'info', dismissAfter = DISSMISS_INTERVAL, additionalInfo = null }
  ) {
    const id = ++state.maxMessageID;

    commit(ADD, createMessage(id, text, additionalInfo, type, dismissAfter));
    if (dismissAfter !== 0) {
      setTimeout(() => commit(REMOVE, id), dismissAfter);
    }
  },

  [REMOVE]({ commit }, id) {
    commit(REMOVE, id);
  },

  setUserThemeOptions({ commit }, payload) {
    console.log('User options', payload);

    if (payload.primary) {
      //Dynamic styles
      let color = tinycolor(payload.primary);

      const primary_variant = tinycolor(color).darken().toString();
      const mReadable = tinycolor
        .mostReadable(color, [primary_variant], { includeFallbackColors: true })
        .toHexString();

      payload.on_primary_color = mReadable;
      payload.primary_variant = primary_variant;
    }

    if (payload.secodary) {
      let secondary_color = tinycolor(payload.secodary);
      const secondary_variant = tinycolor(secondary_color).darken().toString();

      payload.secondary_variant = secondary_variant;
      payload.on_secondary_color = tinycolor
        .mostReadable(color, [secondary_variant], { includeFallbackColors: true })
        .toHexString();
    }

    commit(SET_USER_THEME_OPTIONS, payload);
  },

  setDefaultTheme({ commit }, payload) {
    if (themes[payload]) {
      commit(SET_DEFAULT_THEME, payload);
      console.warn(`Theme finded: ${payload}, will be setted `);
    } else {
      commit(SET_DEFAULT_THEME, 'basic');
      console.warn(
        `No preinstalled theme with the passed name ${payload}, will be setted default one`
      );
    }

    const root = document.documentElement;
    const themeVars = objectToCssVars({ ...(themes[store.getters['UI/selectedTheme']] || {}) });
    Object.keys(themeVars).forEach(key => {
      root.style.setProperty(key, themeVars[key]);
    });
  },

  setLayoutSettings({ commit }, payload) {
    commit(SET_LAYOUT_CONFIG, payload);
  },

  setAvailableLocales({ commit }, payload) {
    commit(SET_AVAILABLE_LOCALES, payload);
  },

  setQueryLocale({ commit }, payload) {
    commit(SET_QUERY_LOCALE, payload);
  },
};
